import { useEffect } from 'react';
import { globalService } from '../../UIContainer/Global/GlobalService';
import { customerService } from '../../Customer/CustomerService';
import { farmService } from '../../Farm/FarmService';
import {
  GetCustomerCheckBoxList,
  GetFarmCheckBoxList,
  GetTagCheckBoxList,
} from '../../EmailAdministration/Common/Common';
import { CheckBoxItem } from '../../../Common/CommonModel';
import { Customer } from '../../Customer/Model/CustomerModel';

interface UseInitDataProps {
  setLoading: (loading: boolean) => void;
  setError: (error: string) => void;
  setCustomers: (customers: Customer[]) => void;
  setIsCustomerFilterVisible: (isVisible: boolean) => void;
  setFarmOptions: (options: CheckBoxItem[]) => void;
  setCustomerOptions: (options: CheckBoxItem[]) => void;
  setTagOptions: (options: CheckBoxItem[]) => void;
  productOption: string;
}

export const useInitData = ({
  setLoading,
  setError,
  setCustomers,
  setIsCustomerFilterVisible,
  setFarmOptions,
  setCustomerOptions,
  setTagOptions,
  productOption,
}: UseInitDataProps) => {
  useEffect(() => {
    loadData();
  }, [productOption]);

  const loadData = () => {
    if (productOption !== '') {
      loadFarms(productOption);
      loadCustomers();
      loadTags();
      setIsCustomerFilterVisible(true);
    }
  };

  const loadFarms = async (product: string) => {
    setLoading(true);
    try {
      const farms = await farmService.getFarmsByProduct(product);
      setFarmOptions(GetFarmCheckBoxList(farms.Items));
    } catch (error) {
      console.error('Error loading farms:', error);
      setError('Error loading farms. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const loadCustomers = async () => {
    setLoading(true);
    try {
      const customers = await customerService.getCustomersByProduct();
      setCustomers(customers.Items);
      setCustomerOptions(GetCustomerCheckBoxList(customers.Items));
    } catch (error) {
      console.error('Error loading customers:', error);
      setError('Error loading customers. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const loadTags = async () => {
    setLoading(true);
    try {
      const tags = await globalService.getTags();
      setTagOptions(GetTagCheckBoxList(tags.Items));
    } catch (error) {
      console.error('Error loading tags:', error);
      setError('Error loading tags. Please try again.');
    } finally {
      setLoading(false);
    }
  };
};
